import styled from "@emotion/styled/macro";
import { tokens } from "@sunrun/experience-ui-components";
import { maxWidth } from "components/atoms/GlobalStyles";

export const HeaderContentLayoutContainer = styled.div`
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(
    180deg,
    ${tokens.CHARGEBLUE_50} 0,
    ${tokens.BACKGROUND_LIGHT} 16rem
  );
  display: grid;
  grid-template-columns: [main] 1fr;
  grid-template-rows: [page-top] auto [header-end] 1fr [content-end] auto;

  @media (max-width: ${maxWidth}px) {
    grid-template-rows: [page-top] 6rem [header-end] 6rem [content-end] auto;
  }
`;
